import {css} from '@emotion/core';
import styled from '@emotion/styled';
import { formInputStyle, formEntryStyle } from '@css/styles';
import { black } from '@css/constants';
import { FontNormal } from '@css/fonts';

export const TextInputContainer = styled('input')(css`
  ${formInputStyle}
  ${formEntryStyle}

  color: ${black};
  box-sizing: border-box;
  width: 100%;
  padding: 6px 10px;
  background-color: white;

  /* Chrome/Opera/Safari */
  ::-webkit-input-placeholder {
    ${FontNormal(500)}
    color: $placeholder-color;
  }
  /* Firefox 19+ */
  ::-moz-placeholder {
    ${FontNormal(500)}
    color: $placeholder-color;
  }
  /* IE 10+ */
  &:-ms-input-placeholder {
    ${FontNormal(500)}
    color: $placeholder-color;
  }
  /* Firefox 18- */
  &:-moz-placeholder {
    ${FontNormal(500)}
    color: $placeholder-color;
  }
  &::placeholder {
    ${FontNormal(500)}
    color: $placeholder-color;
  }
`);
